import React from 'react';
import Slider from "react-slick";
import { FaAngleDoubleLeft ,FaAngleDoubleRight } from "react-icons/fa";

const OfferSlider = () => {
  const settings = {
    arrows: false,
    dots:true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
     autoplay: true,
     autoplaySpeed: 2000,
    // centerPadding: '40px',
    prevArrow: (
        <button className="slick-prev slick-arrow">
<FaAngleDoubleLeft />
        </button>
      ),
      nextArrow: (
        <button className="slick-next slick-arrow">
       <FaAngleDoubleRight />
        </button>
      ),
  };

  return (
    <div>
    
        
      <Slider {...settings}>
        <div>
         <div className="img-wrapper">
         <img src="./images/servey1.png" alt="Slide 1"/>
         </div>
        </div>
        <div>
         <div className="img-wrapper">
         <img src="./images/servey2.png" alt="Slide 1"/>
         </div>
        </div>
        <div>
         <div className="img-wrapper">
         <img src="./images/servey1.png" alt="Slide 1"/>
         </div>
        </div>
    
      
      </Slider>
      </div>
  
  
  );
}

export default OfferSlider;
